// Shared by the member list (AdminMembers) and member profile (AdminMemberProfile)
export const waLink = (phone) => `https://wa.me/${phone.replace(/\D/g, '').replace(/^0/, '44')}`;

export const ROLE_LABELS = { CLUB_ADMIN: 'Admin', COACH: 'Coach', WELFARE: 'Welfare', STAFF: 'Staff', ADULT: 'Adult', GYMNAST: 'Gymnast' };
// What someone is, for a pill: their role names from `roleIds` when the
// club's roles are known (for example "Coach, Finance"), otherwise the label
// for their User.role
export function roleLabel(member, roles) {
  const names = roles && member?.roleIds?.length
    ? roles.filter(r => member.roleIds.includes(r.id)).map(r => r.name)
    : [];
  if (names.length) return names.join(', ');
  return ROLE_LABELS[member?.role] ?? member?.role ?? '';
}

